<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Courses Explorer/Killer Courses -->
<tool-form formTitle="Bottleneck Filter">
  <form
    [formGroup]="programBottleneckCoursesForm"
    (ngSubmit)="programBottleneckFormSubmit()"
    class="form-content"
  >
    <!-- College Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a College</mat-label>
      <mat-select
        formControlName="college"
        required
        (selectionChange)="onCollegeChange()"
      >
        <mat-option *ngFor="let college of filters.colleges" [value]="college">
          {{ college }}</mat-option
        >
      </mat-select>
      <mat-error
        *ngIf="this.programBottleneckCoursesForm.controls['college'].invalid"
        >Please select a college</mat-error
      >
      <progress-bar *ngIf="filterLoading"></progress-bar>
    </mat-form-field>

    <!-- Program Input -->
    <mat-form-field class="filter-form-field">
      <mat-label>Select a Program</mat-label>
      <input
        type="text"
        matInput
        formControlName="program"
        [matAutocomplete]="auto"
      />
      <button
        *ngIf="programBottleneckCoursesForm.value.program"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="programBottleneckCoursesForm.patchValue({ program: '' })"
      >
        <i class="fas fa-times-circle"></i>
      </button>
      <mat-error
        *ngIf="this.programBottleneckCoursesForm.controls['program'].invalid"
        >You must select a program</mat-error
      >
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option
          *ngFor="let program of programOptions | async"
          [value]="program.name"
        >
          {{ program.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Year Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a UWF Year</mat-label>
      <mat-select formControlName="year" required>
        <mat-option *ngFor="let year of filters.years" [value]="year">
          {{ year }}</mat-option
        >
      </mat-select>
      <mat-error
        *ngIf="this.programBottleneckCoursesForm.controls['college'].invalid"
        >Please select a year</mat-error
      >
      <progress-bar *ngIf="filterLoading"></progress-bar>
    </mat-form-field>

    <!-- Semester Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Semester</mat-label>
      <mat-select formControlName="term" required>
        <mat-option *ngFor="let term of filters.terms" [value]="term">
          {{ term }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="this.programBottleneckCoursesForm.controls['term'].invalid"
        >Please select a term</mat-error
      >
      <progress-bar *ngIf="filterLoading"></progress-bar>
    </mat-form-field>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="!programBottleneckCoursesForm.valid"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
